import React, { useState, useContext, useEffect } from 'react';
import FriendItem from '../../components/FriendItem';
import styles from './Friends.module.sass';
import TextInput from '../../components/TextInput';
import router, { Link, useLocation } from 'react-router-dom';
import Icon from '../../components/Icon';
import { ConquerContext } from '../../contexts/ConquerContext';
import { UserContext } from '../../contexts/UserContext';
import Loader from '../../components/LoaderCircle';
import NewFriendModal from './NewFriendModal';
import FriendInstance from '../../../Conquer/FRIENDS/FriendInstance';
import { FRIEND_STATUS } from '../../../Models/ENUM';
import SearchInput from '../../components/SearchInput';
import { SearchContext } from '../../contexts/SearchContext';
import AddIcon from '@mui/icons-material/Add';
import cn from 'classnames';
import Image from '../../components/Image';

const Friends = ({ onSelected, hideSearch = true, simple = false, initialSelectedFriend }) => {

    const {search, setSearch} = useContext( SearchContext );
    const userContext = useContext(UserContext);
    const conquer = useContext(ConquerContext);

    // const [search, setSearch] = useState('');
    const [friends, setFriends] = useState({});
    const [otherUsers, setOtherUsers] = useState([]);
    const [filteredFriends, setFilteredFriends] = useState( {} );
    const [selectedFriend, setSelectedFriend] = useState( {} );

    async function loadFriends() {

        if (!userContext.userData.isLogged) return setFriends({});

        let response = await conquer.Friends.get(true);

        if( !Array.isArray( response ) ) setFriends({});

        let finalFriends = {};
        for( const eachFriend of response ) finalFriends[eachFriend.avatarID] = eachFriend;
        setFriends( finalFriends );

        if( initialSelectedFriend && finalFriends[initialSelectedFriend])  onFriendSelected( finalFriends[initialSelectedFriend] );

    }
    useEffect(() => {loadFriends()}, [userContext.userData]);

    function onFriendAccept( friendID ){

        setFilteredFriends({
            ...filteredFriends,
            [friendID]: { ...filteredFriends[friendID], status: 'active' }
        });

    }

    useEffect( function(){
        let temp = {};
        for (const eachFriend of Object.values(friends)) {
            if ( simple || !search || ( eachFriend.firstName && eachFriend.firstName.toLowerCase().includes(search) ) ) temp[eachFriend.avatarID] = eachFriend;
        }
        setFilteredFriends( temp );
    }, [friends, simple])

    function onFriendSelected( friendData ){

        let result = onSelected( friendData );
        if( result && friendData ) setSelectedFriend( friendData.avatarID );

    }

    // loadOtherUsers();
    useEffect( () =>{

        async function doWork(){
            if( !search || simple ) return setOtherUsers([]);
            let response = await conquer.Avatars.getByUsername(search);
            if( !Array.isArray( response ) ) return setOtherUsers([]);
            let final = [];
            for( const eachUser of response ){
                if( eachUser.avatarID == conquer.Avatars.ME.avatarID || friends[eachUser.avatarID] ) continue;
                final.push( new FriendInstance( conquer, eachUser ) );
            }
            setOtherUsers( final );
        }
        doWork();

    }, [search] );

    function getRemainingButtons(){

        let final = [];

        if( !simple ) return final;

        for( let i = 0; i < 6 - Object.values(filteredFriends).length; i++ ){
            final.push(
                <button key={i} onClick={() => {onFriendSelected()}} className={cn(styles.friendLink, simple && styles.simple)}>
                    <div>
                        <Image src={'/assets/icon_profile_blue.png'} srcDark={'/assets/icon_profile_blue.png'} />
                    </div>
                </button>
            );
        }

        return final;

    }

    // console.log( isSearching, search, simple );

    return (
        <div className={styles.container}>

            {
             !simple && <div className={styles.header}>
                 <div className={styles.header__title_row}>
                     <div>
                         <span className={styles.header__title}>Friends</span>
                     </div>
                 </div>
                 
             </div>
            }

            <div className={cn( styles.header_zone, styles.center)}>
                     <SearchInput className={styles.searchInput} onChange={(value) => {setSearch (value)}} value={search}/> 
            </div>


            <div className={styles.friends_container}>
                {
                    filteredFriends && !(!simple && search) && Object.values(filteredFriends).map( ( friend ) => {
                        return <FriendItem
                            data={friend}
                            id={friend.avatarID}
                            key={friend.avatarID}
                            onFriendAccept={onFriendAccept}
                            onFriendRemoved={loadFriends}
                            onClick={onFriendSelected}
                            simple={simple}
                            isSelected={ !simple && selectedFriend == friend.avatarID}
                        />
                    }  )
                }
                {
                    !(!simple && search) && filteredFriends && Object.values(filteredFriends).length < 6 && getRemainingButtons().map( (button) => {
                        return button;
                    } )
                }
                { otherUsers.length > 0 && !simple && <h3>Other people</h3> }
                {
                    (!simple && search) && Object.values(otherUsers).map( ( friend ) => {
                        friend.status = FRIEND_STATUS.UKNOWN;
                        return <FriendItem
                            data={friend}
                            id={friend.avatarID}
                            key={friend.avatarID}
                            onFriendAccept={onFriendAccept}
                            onFriendRemoved={loadFriends}
                        />
                    }  )
                }
            </div>
        </div>
    );
};

export default Friends;
